module.exports = __webpack_public_path__ + "static/Dash-Screen-for-Website-3281b5cfb67b8f8c74a078fc7087ed03.png";